import {type DataTestAttrs} from '@benchling/js-test-utils';
import React, {useState} from 'react';

import {CardSectionMessageRow, CardSectionRowList, CardSectionRowProps} from '../CardSection';
import {INITIAL_ROWS_TO_DISPLAY, MAX_ROWS_TO_DISPLAY} from '../HomepageConstants';

export function MyWorkRowsList({
  rows,
  emptyMessage,
  emptyMessageDataTestAttrs,
}: {
  rows: Array<CardSectionRowProps>;
  emptyMessage: string;
  emptyMessageDataTestAttrs: DataTestAttrs;
}): JSX.Element {
  const [showMore, setShowMore] = useState(false);
  const maxRows = Math.max(MAX_ROWS_TO_DISPLAY, rows.length);
  const visibleRows = rows.slice(0, showMore ? maxRows : INITIAL_ROWS_TO_DISPLAY);

  return (
    <>
      {rows.length === 0 ? (
        <CardSectionMessageRow message={emptyMessage} dataTestAttrs={emptyMessageDataTestAttrs} />
      ) : (
        <CardSectionRowList rows={visibleRows} />
      )}
      {rows.length > INITIAL_ROWS_TO_DISPLAY && (
        <CardSectionMessageRow
          message={showMore ? 'Show less' : 'Show more'}
          onClick={() => {
            setShowMore(!showMore);
          }}
        />
      )}
    </>
  );
}
